import { IconProps } from './types';

export function Logo({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 28 28" {...props}>
      <path
        fill="#116C4F"
        d="M21.189 26.09a11.093 11.093 0 0 1-3.22-2.462 3.92 3.92 0 0 1-1.287.434c-3.318.519-5.849-4.898-6.318-6.926-.232-.9-.445-1.808-.543-2.732-.427-4.067 4.006-4.53 4.006-4.53 4.388-3.824 1.969-9.61 1.969-9.61-2.756-.151-5.367.965-7.605 2.254-1.872 1.078-4.206.986-5.96-.274a3.913 3.913 0 0 0-.367 4.04l-1.51-.396c-.2.743-.11 1.533.25 2.213.361.681.966 1.204 1.697 1.465a14.211 14.211 0 0 0-.741 3.1C.648 20.029 5.94 26.73 13.385 27.634c4.83.435 6.997-.446 7.83-.972a.33.33 0 0 0 .156-.293.326.326 0 0 0-.182-.278Z"
      />
      <path
        fill="#FCC128"
        fillRule="evenodd"
        d="M26.072 5.98C22.807 1.298 18.934.485 15.796.264c0 0 2.419 5.787-1.969 9.61 0 0-4.434.464-4.006 4.53.098.924.31 1.832.543 2.732.47 2.03 3 7.445 6.318 6.926 3.318-.52 3.859-4.59 3.86-4.591.042-.368-.038-.692-.561-.437-2.037.992-3.249 1.545-5.101.446-1.483-.88-2.21-2.776-2.473-4.426a.325.325 0 0 1 .146-.326.334.334 0 0 1 .36-.004c.923.562 2.139.921 3.097.888 2.042-.074 2.472-1.48 5.314-.807 2.841.672 3.253 3.572 3.258 3.663.021.412.314.553.58.338 3.327-3.56 3.24-9.482.91-12.826Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M10.452 4.74C8.81 4.55 7.562 5.63 7.132 7c-.462 1.468.48 3.17 1.816 3.55.124-.16.253-.314.389-.464-.821-.243-1.707-1.1-1.722-2.077-.014-.915.766-1.97 1.991-1.987 1.207-.017 1.995 1.111 2.037 2.306a7.93 7.93 0 0 1 1-.423l.287-.099c.033-1.508-.943-2.884-2.478-3.065Z"
      />
      <path
        fill="#fff"
        d="M8.917 7.293a.652.652 0 0 0-.552.46.635.635 0 0 0 .219.679.653.653 0 0 0 .98-.207.635.635 0 0 0-.17-.796.65.65 0 0 0-.477-.136Z"
      />
    </svg>
  );
}
